
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "6ac8ee9f477e9b3db40544b6";
              window.beaePageSetting.pageTitle = "Jersey & Shirts"; 
              window.beaePageSetting.pageType = "collection";

          let js_6QKQ27OF = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-ykrcqmousection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ykrcqmou',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ykrcqmou');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ykrcqmou: ', ex)
      };
    

      try {
        let argid = 'beae-ykrcqmousection-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ykrcqmou',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ykrcqmou');
        args.el = args.els[0];
        ((data
) => { document.querySelectorAll('.beae-product-custom-badged-item').forEach(el => {
  const text = el.textContent.trim();

  if (!text) {
    el.style.display = 'none';
  } else {
    el.style.display = 'inline-block';
  }
}); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ykrcqmou: ', ex)
      };
    

      try {
        let argid = 'beae-0k3sa24gsection-featured-collection',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0k3sa24g',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0k3sa24g');
        args.el = args.els[0];
        ((a) => { var d;window.BeaeMoneyFormat||(window.BeaeMoneyFormat=(d=a.el.querySelector(".beae-money-format"))==null?void 0:d.innerHTML);let n=a.el.querySelectorAll(".beae-featuted-collection-nav");const t=a.el.querySelectorAll(".beae-feature-collection-tab-content"),o=a.el.querySelector(".beae-featuted-collection-nav.nav-active"),r=a.el.closest(".beae-body--preview");n.forEach((c,s)=>{a.mode.value=="live"&&!o&&(s===0?(c.classList.add("nav-active"),t[s]&&(t[s].style.display="block",t[s].setAttribute("data-active","true"))):(c.classList.remove("nav-active"),t[s]&&(t[s].style.display="none",t[s].setAttribute("data-active","false"))));let v=!1;c.addEventListener("click",()=>{if(v)return;v=!0,n.forEach(f=>{f.classList.remove("nav-active")}),c.classList.add("nav-active");const x=c.getAttribute("data-handle"),h=a.el.querySelectorAll(".viewall-link");h&&h.forEach(f=>{f.setAttribute("href",`/collections/${x}`)});const g=a.el.querySelector(`.beae-feature-collection-tab-content[data-handle="${x}"]`),u=a.el.querySelector('.beae-feature-collection-tab-content[data-active="true"]');if(a.el.querySelector(".beae-feature-collection-tab-content.content-active")!==null&&a.el.querySelector(".beae-feature-collection-tab-content.content-active").classList.remove("content-active"),u){u.setAttribute("data-active","false");const f=l(u);setTimeout(()=>{u.style.display="none",g&&(g.style.display="block"),setTimeout(()=>{g&&g.setAttribute("data-active","true"),v=!1},50)},f)}else g&&(g.style.display="block"),setTimeout(()=>{g&&g.setAttribute("data-active","true"),v=!1},50)})});function l(c){const v=window.getComputedStyle(c).getPropertyValue("transition-duration");let x=parseFloat(v)*1e3;return v.includes("s")?x=parseFloat(v)*1e3:x=parseFloat(v),x||0}setTimeout(()=>{typeof window.handleSwatchForCardForm=="function"&&window.handleSwatchForCardForm(a),typeof(a==null?void 0:a.promotionPosition)=="number"&&p(a==null?void 0:a.promotionPosition)},100),(["builder"].includes(a.mode.value)||r)&&setTimeout(()=>{typeof window.handleEventFormProductCard=="function"&&window.handleEventFormProductCard()},100);function p(c){if(a.mode.value!="live")return;const s=a.el.querySelectorAll(".beae-slider-items");if(s&&s.length){s.forEach(x=>{const h=a.el.querySelector(".beae-promotion > *");if(!h)return;const g=h.cloneNode(!0),u=x.children;c>=u.length?x.appendChild(g):x.insertBefore(g,u[c]),c===0&&(x.scrollLeft=0)});const v=a.el.querySelector(".beae-promotion");v&&v.remove()}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0k3sa24g: ', ex)
      };
    

      try {
        let argid = 'beae-0k3sa24gsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0k3sa24g',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0k3sa24g');
        args.el = args.els[0];
        ((g) => { window.BeaeSlider&&!g.noRunJs&&window.BeaeSlider(g) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0k3sa24g: ', ex)
      };
    

      try {
        let argid = 'beae-ash4kg8jblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ash4kg8j',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ash4kg8j');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const H=M.el.closest(".beae-slider-items");H&&!H.hasAttribute("data-svg")&&(H==null||H.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),H.setAttribute("data-svg","true"))}let O=M.el.querySelector(".beae-image-content-position"),I,z=window.innerWidth>=768&&M.autoHover;var V=O.querySelector(".beae-img-ratio-control"),L=O.querySelector(".beae-img-comp-container"),T=O.querySelector(".beae-img-comp-container--second");if(V&&T){let H=function(A){let R=0,j;D(),z?O.onmouseover=function(Z){F(Z)}:A.onmousedown=function(Z){F(Z)},O.onmouseup=function(){q()},A.ontouchstart=function(Z){F(Z)},O.ontouchend=function(){q()};function D(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),A.style.left&&parseInt(A.style.left)}function F(Z){check=!1,Z.preventDefault(),Z.clientX?Z.clientX:Z.touches[0].clientX,parseInt(A.style.left),R=1,O.onmousemove=function(K){G(K)},O.ontouchmove=function(K){G(K)}}function q(){R=0,check=!0}function G(Z){if(R==0)return!1;j=J(Z),j<0&&(j=0),j>100&&(j=100),W(j)}function J(Z){const K=O.getBoundingClientRect(),le=(Z.changedTouches?Z.changedTouches[0].clientX:Z.clientX)-K.left;return Math.max(0,Math.min(100,Math.round(le*100/I)))}function W(Z){A.style.left=Z+"%",T.style.clipPath=`polygon(${Z}% 0%, ${Z}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${Z}% 0%, ${Z}% 100%)`}};V&&T&&H(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),H(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",O=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),O.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ash4kg8j: ', ex)
      };
    

      try {
        let argid = 'beae-ndhpdasyblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ndhpdasy',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ndhpdasy');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ndhpdasy: ', ex)
      };
    

      try {
        let argid = 'beae-ppqrnx07block-add-to-cart',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ppqrnx07',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ppqrnx07');
        args.el = args.els[0];
        ((y) => { if(y.mode.value=="builder"){if(!y.els)return;for(let S=0;S<y.els.length;S++)if(S==y.loopIndex){const B=y.els[S].closest("form.beae-product-form-next");if(!B)return;const w=B.querySelector(".beae-add-to-cart--submit"),$=B.getAttribute("data-product_id"),C=B.querySelector('script[data-id="Product-json-'+$+'"]')||B.querySelector("#Product-json-"+$),M=JSON.parse((C!=null&&C.innerHTML?C==null?void 0:C.innerHTML:"{}").replace(/:\s*([,}])/g,": null$1").replace(/,\s*([\]}])/g,"$1")).variants||[];let V=B.getAttribute("data-variant-id"),L=M[0];V&&(L=M.find(N=>N.id==V));const T=w.querySelector(".beae-add-to-cart-text-content");L!=null&&L.available?T&&(M.length>1?T.innerHTML=w.getAttribute("data-choose-options-text"):T.innerHTML=w.getAttribute("data-add-to-cart-text")):T&&(T.innerHTML=w.getAttribute("data-sold-out-text"))}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ppqrnx07: ', ex)
      };
    

      try {
        let argid = 'beae-zznpux16block-quick-add',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zznpux16',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zznpux16');
        args.el = args.els[0];
        ((x) => { if(x.mode.value=="builder"){if(!x.els)return;for(let h=0;h<x.els.length;h++)if(h==x.loopIndex){const g=x.els[h].closest("form.beae-product-form-next");if(!g)return;const u=g.querySelector(".beae-x-quick-add"),f=g.getAttribute("data-product_id"),b=g.querySelector('script[data-id="Product-json-'+f+'"]')||g.querySelector("#Product-json-"+f),m=JSON.parse((b!=null&&b.innerHTML?b==null?void 0:b.innerHTML:"{}").replace(/:\s*([,}])/g,": null$1").replace(/,\s*([\]}])/g,"$1")).variants||[];let y=g.getAttribute("data-variant-id"),S=m[0];y&&(S=m.find(w=>w.id==y));const B=u.querySelector(".beae-quick-add-content");S!=null&&S.available||B&&(B.innerHTML=u.getAttribute("data-sold-out-text"))}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zznpux16: ', ex)
      };
    }; if (window.BEAEBASE) {js_6QKQ27OF()} else {window.BEAEPAGEJS.push(js_6QKQ27OF)} })(); 